import {useTranslation} from "react-i18next";
import {Button} from "../../../Shared/Button";
import ReactCountryFlag from "react-country-flag";
import {AccessTime, Bookmark, Category, MenuBook} from "@mui/icons-material";
import React from "react";
import {ICountryExpertLesson, ICountryExpertLessonPackTopic} from "../../../../types/components/expertCountry";
import {ILessonMode} from "../../../../types/components/expertView";
import {ITopic} from "../../../../types/redux/expert";
import TopicsDescription from "../../ExpertCard/topicsDescription";
import DateAndTime from "../../ExpertCard/DateAndTime";

interface LessonContentProps {
  lesson: ICountryExpertLesson;
  onClickHandler: () => void;
}

const LessonContent = ({
                         lesson,
                         onClickHandler,
                       }: LessonContentProps) => {
  const {t} = useTranslation();
  return (
    <div className="gray_bg">
      <div
        className="title_area"
        // onClick={onClickHandler}
      >
        <h3>
          {lesson?.name}
          <Button
            id="btn-reserve"
            label={t("home.famousExperts.ExpertCard.label.btnReserve")}
            onClick={onClickHandler}
          />
        </h3>
        <h4>{t("categories." + lesson?.category?.name)}</h4>
        {(lesson.schedule?.schedule_date && lesson.schedule?.schedule_time) &&
          <DateAndTime date={lesson.schedule?.schedule_date}
                        time={lesson.schedule?.schedule_time}
          />
        }
        <div className='description'>
          {(lesson.lesson_mode === ILessonMode.SINGLE) ?
            <span className="lesson_description">{lesson?.description}</span> :
            lesson.topic?.map((topic: ICountryExpertLessonPackTopic, index: number) =>
              <TopicsDescription topic={topic.topic.topic}
                                 description={topic.topic.description}
                                 index={index}
                                 date={topic.schedule_date}
                                 time={topic.schedule_time}
              />
            )
          }
        </div>
        <div className="country_area">
          <ReactCountryFlag
            countryCode={lesson?.country?.code}
            svg
            className="flag"
          />
          <div className="country_name">
            {t("countries." + lesson?.country.name)}
          </div>
        </div>
      </div>
      <div className="info_area">
        <div className="info_single">
          <MenuBook/>
          <span>
            <b>{lesson.lesson_mode === ILessonMode.SINGLE ? 1 : lesson?.topic?.length}</b> {t("common.Lesson(s)")}
          </span>
        </div>
        <div className="info_single">
          <AccessTime/>
          <span>
            <b>30 {t("common.min")}</b>/{t("common.lesson")}
          </span>
        </div>
        <div className="info_single">
          <Bookmark/>
          <span>
            <b>{lesson?.points}</b> {t("common.Points")}
          </span>
        </div>
        <div className="info_single">
          <Category/>
          <span>
            <b>
              {lesson?.lesson_type === 1
                ? t("common.individual")
                : t("common.group")}
            </b>
          </span>
        </div>
      </div>
    </div>
  );
};

export default LessonContent;